import React, { useEffect } from "react";
import useGeoLocation from "../hooks/useGeoLocation";
import usePageMeta from "../hooks/usePageMeta";
import HomeView from "../components/Home/HomeView";
function Home() {
  //const { location, address, error } = useGeoLocation();
  usePageMeta(
    "Jhatka Byte – Fresh Black Bengal Jhatka Mutton Delivery in Kolkata, Barrackpore, Kalyani & Bardhaman",
    "Order fresh Black Bengal jhatka mutton online in Kolkata, Barrackpore, Kalyani and Bardhaman. Hygienic, FSSAI-licensed meat delivered to your door by Jhatka Byte."
  );

  return (
    <>
      <HomeView />
    </>
  );
}

export default Home;
